import { useSyncExternalStore } from 'react';
import { Preferences } from '../../components/consent-modal/types';

type Listener = () => void;

let consentGranted = false;
const listeners = new Set<Listener>();

export function isAnalyticsConsentGranted(prefs?: Preferences): boolean {
	return prefs?.analytics === true;
}

export function getAnalyticsConsent(): boolean {
	return consentGranted;
}

export function setAnalyticsConsent(next: boolean): void {
	if (consentGranted === next) {
		return;
	}
	consentGranted = next;
	listeners.forEach((listener) => listener());
}

export function subscribeAnalyticsConsent(listener: Listener): () => void {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
}

export function useAnalyticsConsent(): boolean {
	return useSyncExternalStore(
		subscribeAnalyticsConsent,
		getAnalyticsConsent,
		() => false
	);
}
